define('modules/page_listing/views/search_list_item',['require','exports','module','base/itemview','ldsh!../templates/tag'],function(require,exports,module){
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/tag"),
    tagName: "li",
    className: "ed-search-list-item",
    triggers: {
      "click .js-select-tag": "tag:select"
    },
    initialize: function() {
      this.listenTo(this.model, "tag:selected", this.highligthTag);
    },
    highligthTag: function() {
      this.$el.addClass("is-focused");
    }
  });
});

